import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const SHOWCASE_IMG =
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const Showcase = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });

  // Image shrinks and rounds as you scroll through the section (cult.fit style)
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.72]);
  const radius = useTransform(scrollYProgress, [0, 1], [0, 40]);
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);
  const textY = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.4, 0.8, 1], [0, 1, 1, 0.3]);

  return (
    <section ref={ref} data-testid="showcase-section" className="relative h-[180vh] bg-black">
      <div className="sticky top-0 h-screen flex items-center justify-center overflow-hidden px-2 sm:px-6">
        <motion.div
          style={{ scale, borderRadius: radius }}
          className="relative w-full h-[88vh] overflow-hidden will-change-transform"
        >
          <motion.img
            src={SHOWCASE_IMG}
            alt="Train hard"
            style={{ scale: imgScale }}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/45" />

          <motion.div
            style={{ y: textY, opacity: textOpacity }}
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-6"
          >
            <span className="text-gold font-semibold uppercase tracking-[0.3em] text-sm mb-4">
              No Excuses
            </span>
            <h2 className="font-bebas text-6xl sm:text-7xl lg:text-9xl text-white leading-[0.9]">
              Train Hard.<br />Stay Golden.
            </h2>
            <p className="text-zinc-200 font-body mt-5 max-w-lg">
              Every rep counts. Every day matters. We give you the place, the people and the push.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
